module.exports = __webpack_public_path__ + "986b5643b26512ab5a43e171cec879d3.svg";